import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import styles from './index.module.scss';

import { Accordion } from '@/routes/_embaUserLayout/-components/Accordion';
import { CertificateButton } from '@/routes/_embaUserLayout/-components/CertificateButton';
import { LearnerPageBreadCrumb } from '@/routes/_embaUserLayout/-components/LearnerPageBreadCrumb';
import { LearnerPageTitle } from '@/routes/_embaUserLayout/-components/LearnerPageTitle';
import { SkillCheckTestButton } from '@/routes/_embaUserLayout/-components/SkillCheckTestButton';

export const USER_ATTENDANCE_FRAGMENT = graphql(/* GraphQL */ `
  fragment EmbaUserAttendanceForLearnerPage on UserAttendance {
    id
    slug
    status
    skillCheckTestAccessible
    certificate {
      fileRedirectUrl
    }
    embaCourse {
      name
      slug
      chapters {
        id
        ...EmbaCourseChapter
      }
    }
  }
`);

export type CourseLessonsPageProps = {
  embaUserAttendance: FragmentType<typeof USER_ATTENDANCE_FRAGMENT>;
};

export const CourseLessonsPage = ({
  embaUserAttendance,
}: CourseLessonsPageProps) => {
  const embaUserAttendanceData = useFragment(
    USER_ATTENDANCE_FRAGMENT,
    embaUserAttendance,
  );

  return (
    <div className={styles.lessons}>
      <LearnerPageBreadCrumb
        title={`「${embaUserAttendanceData.embaCourse.name}」レッスン一覧`}
      />
      <LearnerPageTitle
        title={`「${embaUserAttendanceData.embaCourse.name}」レッスン一覧`}
      />

      <div className={styles.actionArea}>
        <div className={styles.skillCheckTestButtonArea}>
          <SkillCheckTestButton
            userAttendanceSlug={embaUserAttendanceData.slug}
            disabled={!embaUserAttendanceData.skillCheckTestAccessible}
            completed={embaUserAttendanceData.status === 'completed'}
          />
        </div>
        <CertificateButton
          fileRedirectUrl={embaUserAttendanceData.certificate?.fileRedirectUrl}
          disabled={!embaUserAttendanceData.certificate}
        />
      </div>
      <ul>
        {embaUserAttendanceData.embaCourse.chapters.map((chapter) => (
          <Accordion
            key={chapter.id}
            chapter={chapter}
            onClick={() => {}}
            embaUserAttendanceSlug={embaUserAttendanceData.slug}
            type="lessons"
          />
        ))}
      </ul>
    </div>
  );
};
